import DerivativeRankingStatCalculatorBase from "./DerivativeRankingStatCalculatorBase.js";

class SelectiveRankingStatCalculatorBase extends DerivativeRankingStatCalculatorBase {
    constructor(supportedParams) {
        super();
        if (!(supportedParams instanceof Array)) {
            throw new TypeError('supportedParams must be an array');
        }
        if (!supportedParams.length) {
            throw new Error('supportedParams must contain at least one parameter');
        }

        this.supportedParams = [];
        for (let p = 0; p < supportedParams.length; p++) {
            this.addParameter(supportedParams[p]);
        }
    }

    addParameter(parameter) {
        if (!this.isParameterValid(parameter)) {
            throw new TypeError('parameter must be an object with key and aggregator properties');
        }

        this.supportedParams.push(parameter);
    }

    canCalculateStat(parameter) {
        return this.supportedParams.some(p => p === parameter || p.key === parameter.key);
    }

    calculateStat(parameter, dependencies) {
        throw new Error('calculateStat not implemented');
    }
}

export default SelectiveRankingStatCalculatorBase;